/* Native Shopify routes and forms remain authoritative. No analytics or external services. */
(function () {
  'use strict';
  let returnFocus;
  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialog);
      if (dialog) { returnFocus = opener; dialog.showModal(); }
    }
    const close = event.target.closest('[data-close]');
    if (close) close.closest('dialog').close();
    const example = event.target.closest('[data-example]');
    if (example) {
      const dialog = document.getElementById('hsm-example');
      dialog.querySelector('#example-title').textContent = example.dataset.example;
      dialog.querySelector('[data-example-copy]').textContent = example.dataset.description || 'Eine Produktidee für deinen Alltag.';
      returnFocus = example;
      dialog.showModal();
    }
    const qty = event.target.closest('[data-qty]');
    if (qty) {
      const input = qty.closest('.quantity').querySelector('input');
      const max = input.max ? Number(input.max) : 999;
      const min = input.min !== '' ? Number(input.min) : 1;
      const step = Number(input.step) || 1;
      input.value = String(Math.max(min, Math.min(max, (Number(input.value) || min) + Number(qty.dataset.qty) * step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const thumbnail = event.target.closest('[data-gallery-image]');
    if (thumbnail) {
      const image = thumbnail.closest('[data-product-section]').querySelector('[data-main-image]');
      if (image) { image.src = thumbnail.dataset.galleryImage; image.srcset = ''; image.alt = thumbnail.dataset.alt || ''; }
    }
  });
  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const section = select.closest('[data-product-section]');
    section.querySelector('[data-variant-price]').textContent = option.dataset.price;
    const button = section.querySelector('[data-buy-button]');
    button.disabled = option.dataset.available !== 'true';
    button.querySelector('span').textContent = button.disabled ? 'Ausverkauft' : 'In den Warenkorb';
    const image = section.querySelector('[data-main-image]');
    if (image && option.dataset.image) { image.src = option.dataset.image; image.srcset = ''; }
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  });
  function initDialogs(root) {
    root.querySelectorAll('dialog').forEach(function (dialog) {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';
      dialog.addEventListener('close', function () { if (returnFocus && returnFocus.isConnected) returnFocus.focus(); });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
    });
  }
  initDialogs(document);
  document.addEventListener('shopify:section:load', function (event) { initDialogs(event.target); });

  function closeCategoryMenus(except) {
    document.querySelectorAll('[data-category-disclosure][open]').forEach(function (menu) {
      if (menu !== except) menu.open = false;
    });
  }
  document.addEventListener('toggle', function (event) {
    if (event.target.matches('[data-category-disclosure]') && event.target.open) closeCategoryMenus(event.target);
  }, true);
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-category-disclosure]')) closeCategoryMenus();
  });
  document.addEventListener('focusin', function (event) {
    document.querySelectorAll('[data-category-disclosure][open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const openMenu = event.target.closest('[data-category-disclosure][open]');
    if (!openMenu) return;
    event.preventDefault();
    event.stopPropagation();
    openMenu.open = false;
    openMenu.querySelector('summary').focus();
  });
  document.addEventListener('close', function (event) {
    if (event.target.id === 'hsm-menu') closeCategoryMenus();
  }, true);
}());
